import React from 'react';
import { BitbucketLightTheme } from '../../assets/bitbucket/light-theme';
import { DesktopOnlyBackground } from '../../common/ui';
export var BitbucketBackground = function BitbucketBackground(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DesktopOnlyBackground, {
    background: BitbucketLightTheme
  }, children);
};